import { Platform } from 'react-native';
import _ from 'lodash';
import axios from 'axios';
import querystring from 'querystring';

export default class APIClient {

  static generateBaseURL = () => {
    return (global.__APP_MODE__ === 'local'
      ? (
        Platform.OS === 'android'
          ? 'http://10.0.2.2:5001'
          : 'http://localhost:5001'
      )
      : (
        global.__APP_MODE__ === 'dev'
          ? (
            Platform.OS === 'web'
              ? 'https://magicud-app-api-kidsup.herokuapp.com'
              : 'http://dev.api.kidsup.net'
          )
          : 'https://api.kidsup.net'
      ));
  };

  static updateCredential (credential) {
    if (APIClient.credential == credential) {
      return;
    }

    // console.log('update credential: ' + JSON.stringify(credential));
    APIClient.credential = credential;
  }

  /**
   * update token to use in Authorization header
   *
   * @param token token to update
   */
  static updateToken = (token) => {
    APIClient.token = token;
  };

  /**
   * parse error to get message
   * @param error
   * @param defaultMessage default message
   */
  static parseErrorMessage = ({
                                error,
                                defaultMessage,
                              }) => {
    if (!_.isNil(error)
      && !_.isNil(error.response)
      && !_.isNil(error.response.data)
      && !_.isNil(error.response.data.error)
      && !_.isNil(error.response.data.error.message)) {
      return error.response.data.error.message;
    }
    return defaultMessage;
  };

  static GET = async (path, params, cancelToken) => {
    return await APIClient.request('GET', path, null, params, null,
      cancelToken);
  };

  static POST = async (path, data, cancelToken) => {
    return await APIClient.request('POST', path, null, null, data, cancelToken);
  };

  static PUT = async (path, data, cancelToken) => {
    return await APIClient.request('PUT', path, null, null, data, cancelToken);
  };

  static DELETE = async (path, data, cancelToken) => {
    return await APIClient.request('DELETE', path, null, null, data,
      cancelToken);
  };

  static paramsPOST = async (path, params, data, cancelToken) => {
    return await APIClient.request('POST', path, null, params, data,
      cancelToken);
  };

  static jsonPOST = async (path, data, cancelToken) => {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };
    return await APIClient.request('post', path, headers, null, data,
      cancelToken);
  };

  static jsonPUT = async (path, data, cancelToken) => {
    const headers = {
      'Content-Type': 'application/json;charset=UTF-8',
    };
    return await APIClient.request('put', path, headers, null, data,
      cancelToken);
  };

  static request = async (method, path, headers, params, data, cancelToken) => {
    try {
      const baseURL = APIClient.generateBaseURL();
      let url = baseURL + path;
      if (_.isNil(params)) {
        params = {};
      }

      if (_.isNil(headers)) {
        headers = {};
      }
      headers['Accept'] = 'application/json';
      if (!_.isEmpty(this._token) && _.isNil(headers['Authorization'])) {
        headers['Authorization'] = this._token;
      }
      if (method === 'GET') {
      } else if (!_.isNil(data)) {
        if (data instanceof FormData) {
          headers['Content-Type'] = 'multipart/form-data';
        } else {
          const contentType = headers['Content-Type'];
          if (contentType === 'application/json;charset=UTF-8') {
            // post using json
          } else {
            // post using x-www-form-urlencoded
            headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
            data = querystring.stringify(data);
          }
        }
      }
      if (process.env.NODE_ENV === 'development') {
        console.log('method: ' + method);
        console.log('headers: ' + JSON.stringify(headers));
        console.log('auth: ', JSON.stringify(APIClient.credential));
        console.log('path: ' + path);
        console.log('url: ' + url);
        console.log('params: ' + JSON.stringify(params));
        console.log('data: ' + data);
        console.log('cancel token: ' + (cancelToken ? 'not null' : 'null'));
      }
      let rawResponse = await axios({
        url: url,
        method: method,
        headers: headers,
        auth: APIClient.credential,
        params: params,
        data: data,
        cancelToken: cancelToken,
      });
      if (process.env.NODE_ENV === 'development') {
        console.log('request url: ', rawResponse.request._url);
      }
      const response = rawResponse.data;
      return {
        response,
      };
    } catch (error) {
      /*if (process.env.NODE_ENV === 'development') {
        console.log('error: ', error);
      }*/
      return {
        error: error,
      };
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/APIClient.js